import React, { useState } from "react";
import PropTypes from 'prop-types';

import { Box, Tab, IconButton } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import { trakrefBlue, Grey1, Grey3 } from "../../../color_utils";
import { trakrefFontFamily, trakrefFontFamilyBold } from "../../../utils";
import Select from "../Select";

const TrakRefTabListStyle = {
    "& .MuiTabs-indicator": {
        display: "flex",
        justifyContent: "center",
        backgroundColor: trakrefBlue,
    },
    "& .MuiButtonBase-root.MuiTab-root": {
        color: Grey1,
        fontSize: "13px",
        fontFamily: trakrefFontFamily,
        padding: 0,
        lineHeight: "18px",
        outline: "none",
        border: "none",
    },
    "& .MuiButtonBase-root.MuiTab-root.Mui-selected": {
        color: {xs: trakrefBlue, lg: Grey1 },
        fontSize: "13px",
        fontFamily: trakrefFontFamilyBold,
        padding: 0,
        lineHeight: "18px",
    },
    "& .MuiTabs-flexContainer": {
        gap: "30px",
    },
    marginLeft: "20px",
    marginRight: "auto"
};

const TabContainerStyle = {
    display: "flex",
    flexDirection: "row",
    alignContenxt: "center",
    justifyContent: "flex-start",
    marginLeft: "10px",
    marginRight: "10px"
};

const TabPanelStyle = { padding: "0px", marginTop: "5px" };

const IconButtonStyle = {
    ":focus": {
        outline: "none"
    },
    ":hover": {
        backgroundColor: "transparent"
    },
    borderRadius: "0px"
}

const ChildTabs = ({
    activeTab,
    onhandleChange,
    labels,
    tabElements,
    tabCustomStyle,
    tabPanelCustomStyle,
}) => {

    const [activeIconButton, setActiveIconButton] = useState(1);

    const onBack = () => {
        if (activeTab > 1) {
            onhandleChange(null, activeTab - 1);
            setActiveIconButton(0);
        }
    }

    const onNext = () => {
        if (labels.length !== activeTab) {
            onhandleChange(null, activeTab += 1);
            setActiveIconButton(1);
        }
    }

    const onActiveTabChange = (e, tab) => {
        setActiveIconButton( activeTab > tab ? 0 : 1);
        onhandleChange(e, tab);
    }

    // Convert labels to options format for Select component
    const selectOptions = labels.map((label, index) => ({
        id: index + 1,
        label: label
    }));

    const handleSelectChange = (e) => {
        const newValue = e.target.value;
        setActiveIconButton(activeTab > newValue ? 0 : 1);
        onhandleChange(null, newValue);
    };

    return (
        <TabContext value={activeTab} sx={{ padding: 0, margin: 0 }}>
            {/* Mobile: Dropdown Select */}
            <Box sx={{ px: 2, pt: 2, display: { xs: 'block', sm: 'none' } }}>
                <Select
                    label="Category"
                    value={activeTab}
                    options={selectOptions}
                    onChange={handleSelectChange}
                    showNullOption={false}
                />
            </Box>

            {/* Tablet/Desktop: Tabs */}
            <Box sx={{ ...TabContainerStyle, ...tabCustomStyle, mx: { xs: '0px !important', lg: "10px !important" }, display: { xs: 'none', sm: 'flex' } }}>
                <IconButton onClick={onBack} sx={{ ...IconButtonStyle, alignContent: "center", display: { xs: 'none', lg: 'flex' }}}>
                    <NavigateBeforeIcon sx={{
                        color: activeIconButton === 0 ? trakrefBlue : Grey3
                    }} />
                </IconButton>
                <TabList onChange={onActiveTabChange} sx={{...TrakRefTabListStyle, ml: { xs: '10px !important', lg: "20px !important" }, color: { xs: '10px !important', lg: "20px !important" }}}>
                    {labels.map((label, index) => (
                        <Tab
                            incid
                            key={`tab-label-${index}`}
                            label={label}
                            value={index + 1}
                        />
                    ))}
                </TabList>
                <IconButton onClick={onNext} sx={{ ...IconButtonStyle, paddingLeft: "13px", display: { xs: 'none', lg: 'flex' }}}>
                    <NavigateNextIcon sx={{
                        color: activeIconButton === 1 ? trakrefBlue : Grey3
                    }}
                    />
                </IconButton>
            </Box>
            {tabElements.map((tab, index) => (
                <TabPanel
                    key={`tab-panel-${index}`}
                    value={index + 1}
                    sx={{ ...TabPanelStyle, ...tabPanelCustomStyle }}
                >
                    {tab}
                </TabPanel>
            ))}
        </TabContext>
    );
};

ChildTabs.propTypes = {
    activeTab: PropTypes.number,
    onhandleChange: PropTypes.func,
    labels: PropTypes.array,
    tabElements: PropTypes.array,
    tabCustomStyle: PropTypes.object,
    tabPanelCustomStyle: PropTypes.object,
};

ChildTabs.defaultProps = {
    activeTab: 0,
};

export default ChildTabs;
